import React from "react";
import Typography from "@shared/v2/Typography";
import Button from "@shared/v2/Button";
import { SpinnerThirdSolidV6 } from "@shared/v2/Icomoon";
import { useIsPlace } from "../reducers/layoutReducer/selectors";

// TODO: make reusable
const RecruiterAiPopular = () => {
  const isPlace = useIsPlace();
  return (
    <div
      className="tw-relative tw-h-[490px] tw-rounded-[16px] tw-w-[626px] before:tw-absolute before:tw-inset-0 before:tw-content-[''] before:tw-bg-[linear-gradient(to_bottom,rgba(255,255,255,0.7)_0%,rgba(255,255,255,0.7)_80%,white)]"
      style={{
        background: "url(/images/bg-addon-popular.jpg) center center/cover no-repeat",
      }}
    >
      <div className="tw-relative tw-h-full tw-rounded-[16px] tw-p-[32px] tw-flex tw-flex-col tw-gap-[16px]">
        <div className="tw-flex tw-flex-col tw-gap-[8px]">
          <Typography variant="headline3" className="!tw-text-24d !tw-font-bold">
            Recruiter.AI
          </Typography>
          <Typography className="tw-max-w-[400px]">
            Revolutionize Real Estate recruiting with AI innovation! Leverage the power of Brivity to post
            open positions, plus qualify and nurture candidates in minutes.
          </Typography>
        </div>
        <div className="tw-flex-1 tw-relative">
          <Button size="medium">{isPlace ? "Launch" : "Purchase"}</Button>
          <div
            className="tw-absolute tw-top-[60px] tw-right-[35px] tw-w-[364px] tw-h-[240px] tw-rounded-[10px] tw-bg-white tw-shadow-card"
            style={{
              background: "url(/images/bg-addon-popular-recruiter-graph.jpg) center center/cover no-repeat",
            }}
          />
          <div className="tw-absolute tw-right-[23px] tw-top-0 tw-flex tw-gap-[6px] tw-items-baseline tw-px-[20px] tw-py-[29px] tw-rounded-[10px] tw-bg-white tw-shadow-card">
            <span className="tw-text-theme-primary tw-block tw-text-[38px] tw-leading-none">+150</span>
            <span className="tw-text-gray-50 tw-text-[20px] tw-leading-none">Candidates</span>
          </div>
          <div className="tw-absolute tw-left-0 tw-bottom-[53px] tw-flex tw-flex-col tw-items-center tw-w-[295px] tw-p-[18px] tw-rounded-[10px] tw-bg-white tw-shadow-card">
            <SpinnerThirdSolidV6 className="tw-mb-[15px]" />
            <div className="tw-w-full tw-px-[16px] tw-mb-[8px]">
              <div className="tw-relative tw-bg-neutral-gray-10 tw-overflow-hidden tw-rounded-[8px] tw-h-[8px]">
                <div className="tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-1/2 tw-bg-theme-primary tw-rounded-[8px]" />
              </div>
            </div>
            <span>Generating new summary with AI....</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecruiterAiPopular;
